<app-navbar id="navbar"></app-navbar>
<!--<div class="lds-ripple" *appShellRender>-->
<!--  <div></div>-->
<!--  <div></div>-->
<!--</div> *appNoShellRender-->
<div>
  <router-outlet id="content" [attr.data-home]="this.insidePageCheck || city != 'sofia' ? 'no' : 'yes' "></router-outlet>
  <zav-splash></zav-splash>
  <zav-footer *appNoShellRender></zav-footer>
</div>
